// renderable.ts
import "lit";
